import { api } from './../../api.js';
import { config } from './../../config.js';
const actions = {
    FRONT_AYUDA: function({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.ayuda'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
}

export default { actions };